import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "../../../lib/utils.js";

export interface SwitchProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onChange" | "role"> {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(function Switch(
  { checked, onCheckedChange, className, disabled, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      {...props}
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      data-state={checked ? "checked" : "unchecked"}
      className={cn(
        "relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border p-0.5 transition-colors duration-150",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent/50",
        "disabled:cursor-not-allowed disabled:opacity-60",
        checked ? "border-accent bg-accent" : "border-line-strong bg-surface-muted",
        className,
      )}
      onClick={() => onCheckedChange(!checked)}
    >
      <span
        aria-hidden="true"
        className={cn(
          "pointer-events-none absolute top-0.5 start-0.5 block size-4 rounded-full bg-white shadow-sm transition-transform duration-150",
          checked && "ltr:translate-x-4 rtl:-translate-x-4",
        )}
      />
    </button>
  );
});
